import api from '@cannect/services/api'

export interface GoogleReview {
  author: string
  authorPhoto: string
  rating: number
  text: string
  time: number
  date: string
  relativeTime: string
}

export interface GoogleReviewsResponse {
  success: boolean
  business: {
    name: string
    overallRating: number
    totalReviews: number
  }
  fiveStarReviews: {
    total: number
    reviews: GoogleReview[]
  }
}

export const getGoogleReviews = async () => {
  return api
    .get<GoogleReviewsResponse>('/google-reviews/five-stars')
    .then(({ data }) => data)
    .catch((error) => {
      console.error('Erro ao buscar Google Reviews:', error)
      throw error
    })
}
